import * as tslib_1 from "tslib";
import { Base } from '../../components/base-component';
import './form-item-access-quote-upl.component.scss';
var FormItemAccessQuoteUpl = /** @class */ (function (_super) {
    tslib_1.__extends(FormItemAccessQuoteUpl, _super);
    function FormItemAccessQuoteUpl(element) {
        return _super.call(this, element) || this;
    }
    FormItemAccessQuoteUpl.prototype.init = function () {
        this.form = this.element.querySelector("form");
        this.submitBtn = Array.from(this.element.querySelectorAll(".js-apply-now-upl__button"));
        this.callMeBackButton = this.element.querySelector(".js-apply-now-pc__button--cmb");
        this.applyOnlineButton = this.element.querySelector(".js-hs-applyOnline-button");
        this.bttDate = this.element.querySelector("input[name=date]");
        this.bttTime = this.element.querySelector("input[name=time]");
        this.formFields = this.element.querySelector(".form__fields--container");
        this.thankYouContainer = this.element.querySelector(".form__thankyou--container");
        this.approvedContainer = this.element.querySelector(".form__success--container-pc");
        this.completeContainer = this.element.querySelector(".form__success--container");
        this.noInterestSurveyContainer = this.element.querySelector(".form__survey--container");
        this.noInterestSurveyCompleteContainer = this.element.querySelector(".form__survey--message");
        this.initialForm = this.element.querySelector(".form__fields--container-pcfields");
        this.callMedBackForm = this.element.querySelector(".form__fields--container-cmbfields");
        this.applyOnlineForm = this.element.querySelector(".form__success--container-applyOnline");
        this.closeButton = Array.from(this.element.querySelectorAll(".upl--close-modal"));
        this.notInterestedInLoanLink = this.element.querySelector("a[name=no-interest-in-loan-link]");
        this.notInterestedSubmitSurveyBtn = this.element.querySelector(".js-upl-submit-survey-button");
        this.formPostData = "";
    };
    FormItemAccessQuoteUpl.prototype.bindEvents = function () {
        var _this = this;
        this.submitBtn.map(function (item) { return item.addEventListener("click", function (event) {
            var _button = event.target;
            var _form = _button.closest("form");
            var formFields = _form.querySelectorAll("input, select");
            _this.validationService.validate(formFields);
            var valid = Array.from(_form.querySelectorAll(".form__group--error"));
            if (valid.length === 0) {
                _this.submitForm(_form);
            }
        }); });
        if (this.closeButton) {
            this.closeButton.map(function (item) { return item.addEventListener("click", function (event) {
                _this.closeModals();
            }); });
        }
        if (this.callMeBackButton) {
            this.callMeBackButton.addEventListener("click", function (event) {
                if (_this.bttDate) {
                    _this.bttDate.classList.add("form__input--required");
                }
                if (_this.bttTime) {
                    _this.bttTime.classList.add("form__input--required");
                }
                _this.formFields.classList.add("active");
                _this.formFields.classList.remove("hidden");
                _this.initialForm.classList.add("hidden");
                _this.initialForm.classList.remove("active");
                _this.callMedBackForm.classList.add("active");
                _this.callMedBackForm.classList.remove("hidden");
                _this.approvedContainer.classList.add("hidden");
                _this.approvedContainer.classList.remove("active");
                _this.applyOnlineForm.classList.add("hidden");
                _this.applyOnlineForm.classList.remove("active");
                _this.completeContainer.classList.add("hidden");
                _this.completeContainer.classList.remove("active");
                _this.noInterestSurveyContainer.classList.add("hidden");
                _this.noInterestSurveyContainer.classList.remove("active");
                _this.noInterestSurveyCompleteContainer.classList.add("hidden");
                _this.noInterestSurveyCompleteContainer.classList.remove("active");
                var credCheck = _this.element.querySelector("input[name=creditcheck]");
                credCheck.value = "false";
                var _formName = _this.form.getAttribute("data-frmcontainer");
                if (_formName !== "") {
                    _this.form.setAttribute("data-frmcontainer", _formName + " cmb");
                }
                _this.analyticsService.dtmRestartForm();
            });
        }
        if (this.applyOnlineButton) {
            this.applyOnlineButton.addEventListener("click", function (event) {
                _this.approvedContainer.classList.add("hidden");
                _this.approvedContainer.classList.remove("active");
                _this.applyOnlineForm.classList.add("active");
                _this.applyOnlineForm.classList.remove("hidden");
            });
        }
        if (this.notInterestedInLoanLink) {
            this.notInterestedInLoanLink.addEventListener("click", function (event) {
                var success = _this.element.querySelector(".form__success--container");
                var successUplScreen = _this.element.querySelector(".form__success--container-pc");
                var noInterestInLoanScreen = _this.element.querySelector(".form__survey--container");
                success.classList.add("hidden");
                success.classList.remove("active");
                successUplScreen.classList.add("hidden");
                successUplScreen.classList.remove("active");
                noInterestInLoanScreen.classList.add("active");
                noInterestInLoanScreen.classList.remove("hidden");
            });
        }
        if (this.notInterestedSubmitSurveyBtn) {
            this.notInterestedSubmitSurveyBtn.addEventListener("click", function (event) {
                _this.submitSurvey();
            });
        }
        if (this.form) {
            var _formFields = Array.from(this.form.querySelectorAll("input, select, textarea"));
            if (_formFields) {
                _formFields.forEach(function (pEement) {
                    pEement.addEventListener("blur", function (pEvent) {
                        _this.validationService.validateBlur(pEvent.currentTarget);
                    });
                });
            }
        }
        // Reset the form
        this.form.addEventListener("custom_form_reset_event", function (e) {
            var _formName = _this.form.getAttribute("data-frmcontainer");
            _formName = _formName.replace(" cmb", "");
            _this.form.setAttribute("data-frmcontainer", _formName);
        }, false);
    };
    FormItemAccessQuoteUpl.prototype.closeModals = function () {
        var _allModals = Array.from(document.querySelectorAll(".js-apply-now-modal"));
        _allModals.forEach(function (_modal) {
            _modal.classList.add("modal--closed");
            _modal.classList.remove("modal--close");
        });
    };
    FormItemAccessQuoteUpl.prototype.submitForm = function (form) {
        var _this = this;
        var _product = this.element.querySelector("input[name=product]");
        if (_product) {
            this.analyticsService.startDtmApplication("application:personal loans:" + _product.value, _product.value);
        }
        else {
            this.analyticsService.startDtmApplication("application:personal loans:", "");
        }
        // success screens
        var loader = form.querySelector(".form__loader--container");
        var thankYou = form.querySelector(".form__thankyou--container");
        var fieldsContainer = form.querySelector(".form__fields--container");
        // additional containers
        var declined = form.querySelector(".form__declined--container");
        var success = form.querySelector(".form__success--container");
        var successUpl = form.querySelector(".form__success--container-pc");
        var noInterestSurvey = form.querySelector(".form__survey--container");
        var noInterestSurveyComplete = form.querySelector(".form__survey--message");
        var error = form.querySelector(".form__error--container");
        var value = form.querySelector(".output-value");
        var name = Array.from(form.querySelectorAll(".form__success-container__firstname"));
        var qualifiedAmount = form.querySelector(".form__success-container__approvedamount");
        var _initialForm = form.querySelector(".form__fields--container-pcfields");
        var _callMeBackForm = form.querySelector(".form__fields--container-cmbfields");
        // loader + hide form
        loader.classList.add("active");
        fieldsContainer.classList.add("hidden");
        fieldsContainer.classList.remove("active");
        // hide survey
        noInterestSurvey.classList.add("hidden");
        noInterestSurvey.classList.remove("active");
        noInterestSurveyComplete.classList.add("hidden");
        noInterestSurveyComplete.classList.remove("active");
        // variables
        var description = form.querySelector("input[name=description]");
        var firstName = form.querySelector("input[name=first-name]");
        var lastName = form.querySelector("input[name=last-name]");
        var contact = form.querySelector("input[name=phone-number]");
        var contact2 = form.querySelector("input[name=phone-number-2]");
        var gross = form.querySelector("input[name=gross]");
        var monthlyexpenses = form.querySelector("input[name=monthlyexpenses]");
        var idNum = form.querySelector("input[name=identification]");
        var email = form.querySelector("input[name=email]");
        var date = form.querySelector("input[name=date]");
        var time = form.querySelector("select[name=time]");
        // Credit check reset
        var credCheck = this.element.querySelector("input[name=creditcheck]");
        var initailCredCheck = this.element.querySelector("input[name=initialCreditcheck]");
        var creditCheckValue = credCheck.value;
        if (initailCredCheck) {
            credCheck.value = initailCredCheck.value;
        }
        var _dateTime = "anytime";
        if (date && time) {
            if (time.value !== "Anytime") {
                _dateTime += date.value + " " + time.value;
            }
        }
        this.formPostData = "";
        var _postData = {
            'description': (description ? description.value : ""),
            'firstName': (firstName ? firstName.value : ""),
            'lastName': (lastName ? lastName.value : ""),
            'contact': (contact ? contact.value : ""),
            'contact2': (contact2 ? contact2.value : ""),
            'gross': (gross ? gross.value : ""),
            'monthlyexpenses': (monthlyexpenses ? monthlyexpenses.value : ""),
            'idNum': (idNum ? idNum.value : ""),
            'email': (email ? email.value : ""),
            'timeToCall': _dateTime,
            'source': this.formsService.isMobile(),
            'creditcheck': (creditCheckValue),
            'not-intersted-minisurvey': ""
        };
        this.analyticsService.startDtmApplication("application:personal loans:" + description.value, description.value);
        // Mini Survey Parameters
        if (creditCheckValue === "false") {
            _postData["not-intersted-minisurvey"] = "NO";
        }
        this.formPostData = _postData;
        var url = this.baseUrl + "/services/SubmitApplicationFormNIUPL.jsp";
        this.formsService.postForm(url, this.http.serialiseObject(_postData)).then(function (pResponse) {
            var data = pResponse.data;
            // service ok
            loader.classList.remove("active");
            if (!data.error && (data.amount || data.code || data.leadID)) {
                if (data.amount) {
                    _this.analyticsService.offerDtmApplication(data.amount, (data.leadID ? data.leadID : null));
                    _this.analyticsService.dtmFormComplete("complete", "true");
                    thankYou.classList.add("active");
                    declined.classList.remove("active");
                    error.classList.remove("active");
                    if (creditCheckValue === "true") {
                        successUpl.classList.add("active");
                        successUpl.classList.remove("hidden");
                        success.classList.remove("active");
                        success.classList.add("hidden");
                    }
                    else {
                        successUpl.classList.add("hidden");
                        successUpl.classList.remove("active");
                        success.classList.add("active");
                        success.classList.remove("hidden");
                    }
                    name.map(function (_item) {
                        _item.innerHTML = firstName.value;
                    });
                    value.innerHTML = "R" + data.amount;
                    if (qualifiedAmount) {
                        qualifiedAmount.innerHTML = data.amount;
                    }
                }
                else if (data.code) {
                    _this.analyticsService.dtmFormComplete("complete", data.code);
                    var _tmp = _this.formsService.powerCurveErrors.find(function (item) {
                        return item.code = data.code;
                    });
                    if (_tmp) {
                        _this.analyticsService.rejectedDtmApplication(data.code, _tmp.message);
                        _this.analyticsService.dtmRecordSiteError(_tmp.message);
                    }
                    else {
                        _this.analyticsService.rejectedDtmApplication(data.code, "Access Quote Declined");
                        _this.analyticsService.dtmRecordSiteError("Access Quote Declined");
                    }
                    thankYou.classList.add("active");
                    thankYou.classList.remove("hidden");
                    declined.classList.add("active");
                    declined.classList.remove("hidden");
                    success.classList.add("hidden");
                    success.classList.remove("active");
                    error.classList.add("hidden");
                    error.classList.remove("active");
                    successUpl.classList.add("hidden");
                    successUpl.classList.remove("active");
                }
                else if (data.leadID) {
                    _initialForm.classList.add("active");
                    _initialForm.classList.remove("hidden");
                    _callMeBackForm.classList.add("hidden");
                    _callMeBackForm.classList.remove("active");
                    _this.analyticsService.dtmFormComplete("complete", data.leadID);
                    thankYou.classList.add("active");
                    thankYou.classList.remove("hidden");
                    success.classList.add("active");
                    success.classList.remove("hidden");
                    error.classList.add("hidden");
                    error.classList.remove("active");
                    declined.classList.add("hidden");
                    declined.classList.remove("active");
                    successUpl.classList.add("hidden");
                    successUpl.classList.remove("active");
                }
                else {
                    _this.analyticsService.dtmFormComplete("complete", data.code);
                    var _tmp = _this.formsService.powerCurveErrors.find(function (item) {
                        return item.code = data.code;
                    });
                    if (_tmp) {
                        _this.analyticsService.rejectedDtmApplication(data.code, _tmp.message);
                        _this.analyticsService.dtmRecordSiteError(_tmp.message);
                    }
                    else {
                        _this.analyticsService.rejectedDtmApplication(data.code, "Access Quote Declined");
                        _this.analyticsService.dtmRecordSiteError("Access Quote Declined");
                    }
                    thankYou.classList.add("active");
                    thankYou.classList.remove("hidden");
                    declined.classList.add("active");
                    declined.classList.remove("hidden");
                    success.classList.add("hidden");
                    success.classList.remove("active");
                    error.classList.add("hidden");
                    error.classList.remove("active");
                    successUpl.classList.add("hidden");
                    successUpl.classList.remove("active");
                }
            }
            else {
                _this.analyticsService.dtmRecordSiteError("noerrorcode|invalid fields|" + url);
                thankYou.classList.add("active");
                thankYou.classList.remove("hidden");
                error.classList.add("active");
                error.classList.remove("hidden");
                success.classList.add("hidden");
                success.classList.remove("active");
                declined.classList.add("hidden");
                declined.classList.remove("active");
                successUpl.classList.add("hidden");
                successUpl.classList.remove("active");
            }
            _this.analyticsService.completeDtmApplication();
        }).catch(function (pResponse) {
            // service failed
            _this.analyticsService.dtmRecordSiteError("noerrorcode|service failure occured|" + url);
            loader.classList.remove("active");
            thankYou.classList.add("active");
            thankYou.classList.remove("hidden");
            error.classList.add("active");
            error.classList.remove("hidden");
            success.classList.add("hidden");
            success.classList.remove("active");
            declined.classList.add("hidden");
            declined.classList.remove("active");
            successUpl.classList.add("hidden");
            successUpl.classList.remove("active");
        });
    };
    FormItemAccessQuoteUpl.prototype.submitSurvey = function () {
        var _this = this;
        // no interest screens
        var noInterestInLoanSurvey = this.element.querySelector(".form__survey--container");
        var noInterestInLoanSurveyComplete = this.element.querySelector(".form__survey--message");
        var loader = this.element.querySelector(".form__loader--container");
        // loader + hide form
        noInterestInLoanSurvey.classList.add("hidden");
        noInterestInLoanSurvey.classList.remove("active");
        loader.classList.add("active");
        // variables
        var url = this.baseUrl + "/services/SubmitApplicationFormNIUPL.jsp";
        var _postData = this.formPostData;
        _postData.creditcheck = "false";
        var _checkQualifyAmount = this.element.querySelector("input[name=check-qualify-amount]");
        var _LoanOfferNotExpected = this.element.querySelector("input[name=loan-offer-not-expected]");
        var _shoppingForBestOffer = this.element.querySelector("input[name=shopping-for-best-offer]");
        _postData["not-intersted-minisurvey"] = "YES";
        _postData["check-qualify-amount"] = ((_checkQualifyAmount && _checkQualifyAmount.checked) ? "YES" : "NO");
        _postData["loan-offer-not-expected"] = ((_LoanOfferNotExpected && _LoanOfferNotExpected.checked) ? "YES" : "NO");
        _postData["shopping-for-best-offer"] = ((_shoppingForBestOffer && _shoppingForBestOffer.checked) ? "YES" : "NO");
        var surveyDescription = this.element.querySelector("input[name=surveyDescription]");
        this.analyticsService.startDtmApplication("application:personal loans:" + surveyDescription.value, surveyDescription.value);
        this.formsService.postForm(url, this.http.serialiseObject(_postData)).then(function (pResponse) {
            var data = pResponse.data;
            // service ok
            loader.classList.remove("active");
            // analytics
            _this.analyticsService.dtmFormComplete("complete", "true");
            // containers
            noInterestInLoanSurveyComplete.classList.add("active");
            noInterestInLoanSurveyComplete.classList.remove("hidden");
            _this.analyticsService.completeDtmApplication();
        }).catch(function (pError) {
            loader.classList.remove("active");
            // analytics
            _this.analyticsService.dtmFormComplete("complete", "true");
            // containers
            noInterestInLoanSurveyComplete.classList.add("active");
            noInterestInLoanSurveyComplete.classList.remove("hidden");
        });
    };
    return FormItemAccessQuoteUpl;
}(Base));
export { FormItemAccessQuoteUpl };



//////////////////
// WEBPACK FOOTER
// ./components-wpbbsa/form-item-access-quote-upl/form-item-access-quote-upl.component.ts
// module id = 816
// module chunks = 0